module.exports = __webpack_public_path__ + "img/Bpoint6.79254bc6.png";